
import { defineComponent, useAsync, useMeta } from "@nuxtjs/composition-api";

import { useTranslate } from "@/composables";

export default defineComponent({
  setup() {
    const { t } = useTranslate();

    useAsync(() => {
      const { link } = useMeta();

      link.value.push({
        rel: "preload",
        href: `/videos/home/app-stores-cta/posters/creator-collage/md.webp`,
        type: "image/webp",
        as: "image",
      });
    }, "app-stores-cta-video-preload");

    const videoLabel = t(
      "LTK Creators showcasing different aspects of their lives: one Creator in workout attire, another with her family in coordinated outfits, and a third capturing a humorous everyday moment.",
    );

    return {
      videoLabel,
    };
  },
  head: {},
});
